import { render, staticRenderFns } from "./ManageWebhookEvents.vue?vue&type=template&id=4b0c809e&scoped=true&lang=pug"
import script from "./ManageWebhookEvents.vue?vue&type=script&lang=js"
export * from "./ManageWebhookEvents.vue?vue&type=script&lang=js"
import style0 from "./ManageWebhookEvents.vue?vue&type=style&index=0&id=4b0c809e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0c809e",
  null
  
)

export default component.exports